/**
 * @desc 料耗比分页查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialConsumptionThanTheQueryParameters,
): Promise<defs.StandardReturn<defs.Pager<defs.ConsumptionRatioResponse>>> {
  return defHttp.post({
    url: '/web/consumptionRatio/query',
    data,
  });
}

export function mock(
  data: defs.MaterialConsumptionThanTheQueryParameters,
): Promise<defs.StandardReturn<defs.Pager<defs.ConsumptionRatioResponse>>> {
  return defHttp.post({
    url: '/mock/web/consumptionRatio/query',
    data,
  });
}
